import { ActionType, IAction, IBrowserAction } from '../actions/index';
import * as _ from 'lodash';


export function ui(state = { mobileNavOpen: false}, action: IAction) {
    switch (action.type) {
        case ActionType.TOGGLE_MOBILE_NAV:
            return _.assign({}, state, { mobileNavOpen: !state.mobileNavOpen });

        case ActionType.BROWSER_NAVIGATION:
            return _.assign({}, state, { topicsNavOpen: Boolean });

        default:
            return state;
    }
} 